export default __webpack_public_path__ + "static/media/ldo_NEG_FLOAT_ADJ_EN_nCff.03852145.svg";